<template>
  <div class="shunyi-auth-page">
    <div class="auth-card">
      <van-loading
        v-if="status === 'loading'"
        type="spinner"
        color="#3A8DFF"
        size="32px"
      />
      <van-icon
        v-else-if="status === 'success'"
        name="checked"
        class="auth-card__icon auth-card__icon--success"
      />
      <van-icon
        v-else
        name="warning-o"
        class="auth-card__icon auth-card__icon--error"
      />

      <h1 class="auth-card__title">{{ title }}</h1>
      <p class="auth-card__message">{{ message }}</p>
      <p v-if="detail" class="auth-card__detail">{{ detail }}</p>

      <van-button
        v-if="status === 'error'"
        round
        type="info"
        class="auth-card__button"
        @click="startLogin"
      >
        重新尝试
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  Button,
  Icon,
  Loading
} from 'vant'
import InternetHospitalAuthDao from '@/h5/doucan/network/InternetHospitalAuthDao'

export default {
  name: 'ShunyiAuthPage',
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Loading.name]: Loading
  },
  data () {
    return {
      status: 'loading',
      message: '正在登录',
      detail: ''
    }
  },
  computed: {
    title () {
      if (this.status === 'success') {
        return '登录成功，正在进入'
      }
      if (this.status === 'error') {
        return '登录失败，请从健康顺德小程序重新进入'
      }
      return '正在登录'
    }
  },
  mounted () {
    this.startLogin()
  },
  methods: {
    async startLogin () {
      const {
        appId,
        content,
        openid,
        returnUrl
      } = this.$route.query

      this.status = 'loading'
      this.message = '正在登录'
      this.detail = ''

      if (!appId || !content) {
        this.status = 'error'
        this.message = '授权参数缺失，请从健康顺德小程序重新进入'
        this.detail = '缺少 appId 或 content 参数'
        return
      }

      try {
        const result = await InternetHospitalAuthDao.login({
          appId,
          content,
          openid,
          returnUrl
        })

        if (!result || result.code !== 1 || !result.data) {
          this.status = 'error'
          this.message = (result && result.msg) || '授权登录失败'
          this.detail = '请关闭当前页面后，从健康顺德小程序重新进入'
          return
        }

        this.saveSessionItem('shunyi_internet_hospital_content', content)
        this.applyLoginResult(result.data)
        this.status = 'success'
        this.message = '登录成功，正在进入'
        this.detail = ''

        window.setTimeout(() => {
          this.$router.replace({ path: '/Shunyi/home' })
        }, 300)
      } catch (error) {
        console.error('健康顺德小程序 H5 授权登录异常:', error)
        this.status = 'error'
        this.message = '授权登录异常，请稍后重试'
        this.detail = '请从健康顺德小程序重新进入'
      }
    },
    applyLoginResult (data) {
      const userProfile = {
        isLogin: true,
        userId: data.userId || '',
        phone: data.phone || '',
        name: data.name || '',
        token: data.token || '',
        passwd: '',
        hospitalName: data.registerHospitalName || data.shundeHospitalName || ''
      }

      this.$store.commit('user/setUser', userProfile)
      this.$store.commit('user/setToken', data.token || '')

      if (data.registerHospitalId) {
        this.$store.commit('user/setQrCodeHospitalId', data.registerHospitalId)
      }
      if (data.registerHospitalName || data.shundeHospitalName) {
        this.$store.commit('user/setQrCodeHospital', data.registerHospitalName || data.shundeHospitalName)
      }

      this.saveSessionItem('token', data.token)
      this.saveSessionItem('shunyi_token', data.token)
      this.saveSessionItem('shunyi_user_id', data.userId)
      this.saveSessionItem('shunyi_user_phone', data.phone)
      this.saveSessionItem('shunyi_user_name', data.name)
      this.saveSessionItem('shunyi_hospital_code', data.shundeHospitalCode)
      this.saveSessionItem('shunyi_hospital_name', data.shundeHospitalName)
      this.saveSessionItem('shunyi_register_hospital_id', data.registerHospitalId)
      this.saveSessionItem('shunyi_register_hospital_business_id', data.registerHospitalBusinessId)
      this.saveSessionItem('shunyi_register_hospital_name', data.registerHospitalName)
      this.saveSessionItem('shunyi_home_first_visit_cleared_v1', '1')
    },
    saveSessionItem (key, value) {
      if (value === undefined || value === null || value === '') {
        return
      }
      sessionStorage.setItem(key, String(value))
    }
  }
}
</script>

<style scoped>
.shunyi-auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #EAF7FF 0%, #F7FBFF 48%, #FFFFFF 100%);
}

.auth-card {
  width: 100%;
  max-width: 320px;
  padding: 36px 22px;
  box-sizing: border-box;
  border-radius: 18px;
  background: #FFFFFF;
  text-align: center;
  box-shadow: 0 12px 30px rgba(58, 141, 255, 0.12);
}

.auth-card__icon {
  font-size: 44px;
}

.auth-card__icon--success {
  color: #36C16B;
}

.auth-card__icon--error {
  color: #FF7D45;
}

.auth-card__title {
  margin: 18px 0 8px;
  font-size: 20px;
  line-height: 28px;
  color: #1F2D3D;
  font-weight: 600;
}

.auth-card__message {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: #5D6D7E;
}

.auth-card__detail {
  margin: 10px 0 0;
  font-size: 12px;
  line-height: 18px;
  color: #8A98A8;
}

.auth-card__button {
  width: 180px;
  margin-top: 22px;
}
</style>
